import { ButtonGroup, Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { EdgesButtonGroups, Left, Middle, Right } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";
import CommonGroupButton from "../Common/CommonGroupButton";
import { BUTTON_GROUP } from "../../../../Data/Buttons/ButtonGroup";

const EdgesButtonGroup = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={EdgesButtonGroups} />
        <CardBody className="btn-group-showcase">
          <Row>
            <Col xl="4" md="6" sm="12">
              <ButtonGroup className="btn-group-pill">
                <Btn color="primary">{Left}</Btn>
                <Btn color="primary">{Middle}</Btn>
                <Btn color="primary">{Right}</Btn>
              </ButtonGroup>
            </Col>
            <CommonGroupButton data={BUTTON_GROUP}  buttonClass="btn-group-pill" />
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default EdgesButtonGroup;
